import { useEffect, useRef, useState, type ReactNode } from 'react';
import { cobrancaAtiva } from '../../lib/plano';
import { abrirGrupos } from '../../components/Grupos';
import { VoltarBorda } from '../../components/VoltarBorda';
import { voltarAoMyPlanner } from '../../lib/voltarPlanner';
import { usePendentes } from '../../lib/grupos';
import { Alert, BackHandler, Platform, Pressable, ScrollView, Switch, Text, View } from 'react-native';
import { useIsFocused, useLocalSearchParams, useNavigation, useRouter } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ReentrarModal } from '../../components/Reentrar';
import { useAuth } from '../../auth/AuthContext';
import { setDoc, syncNow, useDoc, useSync, useLiberacao } from '../../store/store';
import { nomeIA } from '../../lib/ia';
import type { AbaId } from '../../store/types';
import { traduzErro } from '../../lib/supabase';
import { brDateTime, horaTela, norm } from '../../lib/date';
import { mascaraCpf, soDigitos } from '../../lib/cpf';
import { Chip, Field } from '../../components/ui';
import { Recolhivel } from '../../components/Recolhivel';
import { tomarPilha } from '../../lib/retomar';
import { ABAS, abasVisiveis, C, aba, useCores } from '../../components/theme';
import { useFeriadosPref } from '../../components/useFeriados';
import { nomePais } from '../../lib/feriadosMundo';
import { versaoCurta } from '../../lib/atualizacoes';
import { modoReal, nomeDoModo } from '../../lib/avisos';
import { IDIOMAS, N_, t, useIdioma } from '../../lib/i18n';
import { moedaDe } from '../../store/financas';
import { BotaoMenu, Card } from '../../screens/ajustes/comum';
import Aparencia from '../../screens/ajustes/Aparencia';
import IdiomaMoeda, { rotuloMoeda } from '../../screens/ajustes/IdiomaMoeda';
import Avisos from '../../screens/ajustes/Avisos';
import Calendario from '../../screens/ajustes/Calendario';
import Seguranca from '../../screens/ajustes/Seguranca';
import Feriados from '../../screens/ajustes/Feriados';
import Compras from '../../screens/ajustes/Compras';
import NuvemCopias from '../../screens/ajustes/NuvemCopias';
import Armazenamento from '../../screens/ajustes/Armazenamento';
import MeusDados from '../../screens/ajustes/MeusDados';
import AgendaMapas from '../../screens/ajustes/AgendaMapas';
import IA from '../../screens/ajustes/IA';
import ComoUsar, { GuiaSubpagina, tituloGuia } from '../../screens/ajustes/ComoUsar';
import { ouvirPaginasAjustes } from '../../lib/guia/destaque';
import { AlvoGuia } from '../../components/guia/Destaque';
import Sobre from '../../screens/ajustes/Sobre';
import { ConfigAba, ListaAbas } from '../../screens/ajustes/Abas';
import { FaleConosco, Indicar, Privacidade } from '../../screens/ajustes/Contato';
import { ConectarNavegador } from '../../components/ConectarNavegador';
import { PaginasDoApp } from '../../components/ConfigPaginas';
import Lixeira from '../../screens/ajustes/Lixeira';
import { ROLAGEM_TECLADO } from '../../components/teclado';
export { ErrorBoundary } from '../../components/Falha';

const WEB = Platform.OS === 'web';
type Pagina = 'aparencia' | 'idioma' | 'avisos' | 'calendario' | 'feriados' | 'paginas' | 'compras' | 'indicar' | 'abas' | 'seguranca' | 'nuvem'
  | 'armazenamento' | 'lixeira' | 'meusdados' | 'agenda' | 'ia' | 'web' | 'comousar' | 'contato' | 'privacidade' | 'sobre' | AbaId
  | `guia:${string}`;   // texto 08: páginas do guia Como usar
const ehAba = (p: Pagina): p is AbaId => ABAS.some(a => a.id === p);

/** O que a busca encontra: opções de dentro das páginas (ícone, nome, página, palavras a mais). */
const OPCOES: [string, string, Pagina | 'discreto', string?][] = [
  ['🌗', N_('Modo'), 'aparencia', 'escuro claro'], ['🎨', N_('Tema'), 'aparencia', 'cores das abas paleta'], ['🖍️', N_('Cor de destaque'), 'aparencia'],
  ['🔠', N_('Tamanho do texto'), 'aparencia', 'letra fonte'], ['📐', N_('Tamanho das caixas'), 'aparencia', 'cartoes'],
  ['🌐', N_('Idioma'), 'idioma', 'lingua'], ['💲', N_('Moeda'), 'idioma', 'dinheiro real dolar euro'],
  ['🔔', N_('Som e vibração'), 'avisos', 'alarme vibracao notificacao'], ['🌙', N_('Não perturbe'), 'avisos', 'silencio'],
  ['💸', N_('Contas a pagar'), 'avisos', 'vencimento antecedencia'], ['🔔', N_('Testar alerta'), 'avisos', 'bateria notificacoes alarmes e lembretes'],
  ['⚙️', N_('Abrir configurações do celular'), 'avisos', 'permissao'],
  ['📅', N_('A semana começa na'), 'calendario', 'segunda domingo'], ['🕐', N_('Formato da hora'), 'calendario', '24h 12h am pm'],
  ['🎉', N_('Feriados'), 'feriados', 'pais estados cidades'],
  ['✒️', N_('Páginas e canetas'), 'paginas', 'folha pauta escrita caneta letras'],
  ['📆', N_('Agenda do Google'), 'agenda', 'calendario google sincronizar'], ['🗺️', N_('Rotas e mapas'), 'agenda', 'waze google maps rota'],
  ['☁️', N_('Google Drive e OneDrive'), 'nuvem', 'nuvem'], ['💾', N_('Exportar arquivo'), 'nuvem', 'backup copia de seguranca'],
  ['📂', N_('Importar arquivo'), 'nuvem', 'backup restaurar'],
  ['🔑', N_('Senha'), 'seguranca', 'mudar senha'], ['👆', N_('Biometria'), 'seguranca', 'digital rosto pin desenho padrao desbloqueio'],
  ['🔐', N_('Cofre'), 'seguranca', 'criptografia'], ['✉️', N_('E-mail de contato'), 'seguranca'], ['📱', N_('Celular confirmado'), 'seguranca', 'whatsapp numero'],
  ['⬇️', N_('Baixar todos os meus dados'), 'meusdados', 'lgpd portabilidade'], ['❌', N_('Excluir minha conta'), 'meusdados', 'apagar conta lgpd'],
  ['🔄', N_('Procurar atualização agora'), 'sobre', 'versao atualizacoes'],
  ['📷', N_('Conectar navegador'), 'web', 'computador qr code'],
  ['⚡', N_('Limite de energia'), 'planner'], ['☕', N_('Pausas'), 'planner', 'emoji pausa tela de bloqueio'],
  ['⏱️', N_('Duração padrão de uma tarefa nova'), 'planner'], ['☀️', N_('Resumo da manhã'), 'planner'],
  ['⏰', N_('Alertas dos compromissos'), 'planner'], ['🎉', N_('Mostrar feriados no topo'), 'planner'], ['🧹', N_('Limpar a agenda'), 'planner'],
  ['🔷', N_('Formatos'), 'planner', 'temporizador concluir formas'],
];

/** CPF mostrado só em parte: 064.***.***-25. */
const cpfParcial = (cpf: string) => { const d = soDigitos(cpf); return d.length === 11 ? `${d.slice(0, 3)}.***.***-${d.slice(9)}` : mascaraCpf(cpf); };

/** Ajustes: a capa em blocos (0.67, texto 05 D3). Cada cartão abre a sua página, com "‹" para voltar. */
export default function Ajustes() {
  const ins = useSafeAreaInsets();
  const router = useRouter();
  const { sec } = useLocalSearchParams<{ sec?: string }>();
  const a = useAuth();
  const sync = useSync();
  const lib = useLiberacao();
  const { accent, liberada } = useCores();
  const pendentes = usePendentes();
  const lang = useIdioma();
  const pref = useFeriadosPref();
  const aj = useDoc('ajustes');
  const fin = useDoc('financas');
  // texto 07 B1: depois de aplicar tema/modo/texto (o app remonta), reabre a mesma página
  const [pilha, setPilha] = useState<Pagina[]>(() => (tomarPilha() as Pagina[] | null) ?? []);
  const [busca, setBusca] = useState('');
  const [verCpf, setVerCpf] = useState(false);
  const [rodape, setRodape] = useState<ReactNode>(null);   // botões fixos embaixo (Aparência: Aplicar/Cancelar)
  const scroll = useRef<ScrollView>(null);
  const pagina = pilha[pilha.length - 1] ?? null;

  const abrir = (p: Pagina) => { setPilha(s => [...s, p]); scroll.current?.scrollTo({ y: 0, animated: false }); };
  const voltar = () => { setPilha(s => s.slice(0, -1)); scroll.current?.scrollTo({ y: 0, animated: false }); };

  // O raio de energia do Planner abre direto as configurações da aba My Planner.
  useEffect(() => {
    if (sec === 'energia') { setPilha(['abas', 'planner']); router.setParams({ sec: undefined } as any); }
    else if (sec === 'nuvem' || sec === 'ia') { setPilha([sec]); router.setParams({ sec: undefined } as any); }
  }, [sec]); // eslint-disable-line react-hooks/exhaustive-deps

  // Guia Como usar (texto 08): "Mostrar na tela" e "Voltar ao guia" pedem para abrir estas páginas.
  useEffect(() => ouvirPaginasAjustes(p => { setBusca(''); setPilha(p as Pagina[]); scroll.current?.scrollTo({ y: 0, animated: false }); }), []);
  // Rolar até um passo do guia (y na janela): onde a rolagem está agora + a distância até o topo da área que rola.
  const desloc = useRef(0);
  const rolarGuia = (y: number) => {
    const ir = (topo: number) => scroll.current?.scrollTo({ y: Math.max(0, desloc.current + y - topo - 90), animated: true });
    const sv = scroll.current as any;
    const no = sv?.getNativeScrollRef?.() ?? sv;
    if (no?.measureInWindow) no.measureInWindow((_x: number, topo: number) => ir(topo || 0)); else ir(0);
  };

  // Tocar em "Ajustes" na barra estando aqui volta para o menu.
  const navigation = useNavigation();
  useEffect(() => (navigation as any).addListener('tabPress', () => { if ((navigation as any).isFocused()) { setPilha([]); setBusca(''); } }), [navigation]);

  // Botão "voltar" do Android volta uma página dentro dos Ajustes (só com Ajustes na tela: 0.70, texto 09 E4).
  const foco = useIsFocused();
  useEffect(() => {
    if (!pagina || !foco) return;
    const sub = BackHandler.addEventListener('hardwareBackPress', () => { voltar(); return true; });
    return () => sub.remove();
  }, [pagina, foco]);

  const [reentrar, setReentrar] = useState(false);
  const syncTxt = sync.status === 'syncing' ? t('Sincronizando...') : sync.status === 'offline' ? t('Sem internet. Envia quando voltar.')
    : sync.status === 'sessao' ? t('Sincronização parada: confirme sua senha. Nada se perde.')
    : sync.status === 'error' ? t('Erro: {erro}', { erro: traduzErro(sync.error) }) : sync.last ? t('Sincronizado em {data}', { data: brDateTime(sync.last) }) : t('Ainda não sincronizado');

  const TITULO: Record<string, string> = {
    aparencia: t('Aparência'), idioma: t('Idioma e moeda'), avisos: t('Avisos e alarmes'), calendario: t('Calendário'), feriados: t('Feriados'),
    seguranca: t('Segurança'), nuvem: t('Nuvem e cópias de segurança'), armazenamento: t('Armazenamento'), ia: t('Inteligência artificial'), compras: t('Compras'), abas: t('Abas do My Planner Anne'),
    privacidade: t('Privacidade e termos'), contato: t('Fale conosco'), indicar: t('Indique e ganhe'), paginas: t('Páginas e canetas'), lixeira: t('Lixeira'),
    meusdados: t('Meus dados'), agenda: t('Agenda e mapas'), web: 'My Planner Web', comousar: t('Como usar'), sobre: t('Atualizações e sobre'),
  };
  const titulo = !pagina ? t('Ajustes') : ehAba(pagina) ? aba(pagina).nome : pagina.startsWith('guia:') ? tituloGuia(pagina.slice(5)) : TITULO[pagina];
  const qtdAbas = ABAS.filter(x => liberada(x.id)).length;
  const qtdComprar = ABAS.length - qtdAbas;

  const discreto = () => setDoc('ajustes', d => ({ ...d, discreto: !d.discreto }));
  const ir = (dest: Pagina | 'discreto') => {
    setBusca('');
    if (dest === 'discreto') return discreto();
    if (ehAba(dest)) { setPilha(['abas', dest]); scroll.current?.scrollTo({ y: 0, animated: false }); return; }
    abrir(dest);
  };

  // ─── Os cartões da capa, em blocos ───
  type Cartao = { k: string; icon: string; titulo: string; resumo?: string; ir: Pagina | 'discreto' | (() => void); direita?: ReactNode; semSeta?: boolean; extra?: string };
  const idi = IDIOMAS.find(i => i.id === lang);
  // texto 07 A1: Geral, Abas, Assinatura, Conexões, Segurança e dados, Ajuda e sobre. [chave, nome, começa aberto, cartões]
  const blocos: [string, string, boolean, Cartao[]][] = [
    ['geral', t('Geral'), true, [
      { k: 'aparencia', icon: '🎨', titulo: t('Aparência'), resumo: `${aj.modo === 'escuro' ? t('Escuro') : t('Claro')} · ${t('Tema e cor de destaque')}`, ir: 'aparencia' },
      { k: 'paginas', icon: '✒️', titulo: t('Páginas e canetas'), resumo: t('Folha, tema e cores da caneta e das letras'), ir: 'paginas' },
      { k: 'idioma', icon: '🌐', titulo: t('Idioma e moeda'), resumo: `${idi ? `${idi.bandeira} ${idi.nome}` : ''} · ${rotuloMoeda(moedaDe(fin), lang)}`, ir: 'idioma' },
      { k: 'avisos', icon: '🔔', titulo: t('Avisos e alarmes'), ir: 'avisos', extra: 'notificacoes',
        resumo: [t(nomeDoModo(modoReal(aj.avisos?.modo ?? 'ambos'))), aj.avisos?.naoPerturbe?.on ? t('Não perturbe {de}–{ate}', { de: horaTela(aj.avisos.naoPerturbe.de), ate: horaTela(aj.avisos.naoPerturbe.ate) }) : ''].filter(Boolean).join(' · ') },
      { k: 'calendario', icon: '📅', titulo: t('Calendário'), ir: 'calendario',
        resumo: `${t('Semana começa na {dia}', { dia: aj.semanaComeca === 'dom' ? t('Domingo') : t('Segunda') })} · ${aj.hora12 ? '12h' : '24h'}` },
      { k: 'feriados', icon: '🎉', titulo: t('Feriados'), resumo: pref.paises.map(p => p === 'BR' ? t('Brasil') : nomePais(p)).join(' · '), ir: 'feriados' },
      { k: 'discreto', icon: '🙈', titulo: t('Modo discreto'), resumo: t('Esconde os valores em dinheiro (R$ •••)'), ir: 'discreto', semSeta: true, extra: 'esconder valores',
        direita: <Switch value={!!aj.discreto} trackColor={{ true: accent }} onValueChange={discreto} /> },
    ]],
    ['abas', t('Abas'), true, [
      { k: 'abas', icon: '🧩', titulo: t('Abas do My Planner Anne'), resumo: t('{n} aba(s) no seu plano · cores e opções de cada uma', { n: qtdAbas }), ir: 'abas' },
    ]],
    ['assinatura', t('Assinatura'), true, [
      { k: 'compras', icon: '🛒', titulo: t('Compras'), ir: 'compras',
        resumo: lib.ilimitado ? t('Acesso ilimitado') : qtdComprar ? t('{n} aba(s) para comprar', { n: qtdComprar }) : t('Você já tem todas as abas.') },
      ...(cobrancaAtiva() ? [{ k: 'indicar', icon: '🎁', titulo: t('Indique e ganhe'), resumo: t('Seu código para amigos ganharem 10 dias com todas as abas'), ir: 'indicar' as Pagina }] : []),
    ]],
    ['conexoes', t('Conexões'), true, [
      ...(!WEB ? [{ k: 'web', icon: '💻', titulo: 'My Planner Web', resumo: t('Usar no computador, pelo navegador'), ir: 'web' as Pagina }] : []),
      { k: 'grupos', icon: '👥', titulo: t('Grupos e convites'), ir: () => abrirGrupos(), resumo: pendentes ? t('{n} recebido(s) para responder', { n: pendentes }) : t('Turmas, pacientes, equipes e convidados'),
        direita: pendentes ? <Text style={{ backgroundColor: C.danger, color: '#fff', fontWeight: '800', borderRadius: 10, paddingHorizontal: 7, overflow: 'hidden' }}>{pendentes}</Text> : undefined },
      ...(pendentes ? [{ k: 'recebidos', icon: '📥', titulo: t('Recebidos'), ir: () => abrirGrupos({ recebidos: true }), resumo: t('Aceitar, editar ou recusar') }] : []),
      { k: 'agenda', icon: '🗺️', titulo: t('Agenda e mapas'), resumo: `${t('Agenda do Google')} · ${t('Rotas e mapas')}`, ir: 'agenda' },
      { k: 'ia', icon: '🤖', titulo: t('Inteligência artificial'), ir: 'ia', resumo: aj.ia?.provedor ? t('Em uso: {ia}', { ia: nomeIA(aj.ia.provedor) }) : t('Claude, ChatGPT ou Gemini') },
    ]],
    ['seguranca', t('Segurança e dados'), false, [
      { k: 'seguranca', icon: '🔐', titulo: t('Segurança'), resumo: t('Senha, biometria, bloqueio e privacidade'), ir: 'seguranca' },
      { k: 'nuvem', icon: '☁️', titulo: t('Nuvem e cópias de segurança'), resumo: t('Google Drive, OneDrive e arquivo de cópia'), ir: 'nuvem', extra: 'backup' },
      { k: 'armazenamento', icon: '💾', titulo: t('Armazenamento'), resumo: t('Espaço livre, dados de cada aba e anexos'), ir: 'armazenamento' },
      { k: 'lixeira', icon: '🗑️', titulo: t('Lixeira'), resumo: t('O que foi excluído nos últimos 30 dias'), ir: 'lixeira' },
      { k: 'meusdados', icon: '📦', titulo: t('Meus dados'), resumo: t('Baixar todos os meus dados e excluir a conta (LGPD)'), ir: 'meusdados' },
    ]],
    ['ajuda', t('Ajuda e sobre'), false, [
      { k: 'comousar', icon: '❓', titulo: t('Como usar'), resumo: t('Guia passo a passo do app e de cada aba'), ir: 'comousar', extra: 'guia ajuda gestos' },
      { k: 'contato', icon: '💬', titulo: t('Fale conosco'), resumo: t('Problemas, erros e sugestões'), ir: 'contato' },
      { k: 'privacidade', icon: '📄', titulo: t('Privacidade e termos'), resumo: t('Política de privacidade, LGPD e permissões'), ir: 'privacidade' },
      { k: 'sobre', icon: '🔄', titulo: t('Atualizações e sobre'), resumo: t('Versão {v}', { v: versaoCurta() }), ir: 'sobre', extra: 'versao' },
    ]],
  ];
  const tocar = (c: Cartao) => (typeof c.ir === 'function' ? (setBusca(''), c.ir()) : ir(c.ir));
  // texto 08 (C1): cada cartão é um alvo do "Mostrar na tela" ('ajustes.<k>'); a View de volta não tem estilo
  const cartao = (c: Cartao) => (
    <AlvoGuia key={c.k} id={'ajustes.' + c.k}>
      <BotaoMenu icon={c.icon} titulo={c.titulo} resumo={c.resumo} direita={c.direita} semSeta={c.semSeta} onPress={() => tocar(c)} />
    </AlvoGuia>
  );

  // ─── Busca: os cartões e as opções de dentro das páginas ───
  const q = norm(busca.trim());
  const achados = (() => {
    if (!q) return null;
    const tem = (...s: (string | undefined)[]) => s.some(x => !!x && norm(x).includes(q));
    const cards = blocos.flatMap(([, , , l]) => l).filter(c => tem(c.titulo, c.resumo, c.extra));
    const vistos = new Set(cards.map(c => c.titulo));
    const opcoes = OPCOES.filter(([, n, , ex]) => tem(t(n), ex) && !vistos.has(t(n))).map(([icon, n, dest]): Cartao => ({
      k: 'op-' + n, icon, titulo: t(n), ir: dest,
      resumo: ehAba(dest as Pagina) ? `${TITULO.abas} › ${aba(dest as AbaId).nome}` : (TITULO[dest] ?? blocos.flatMap(([, , , l]) => l).find(c => c.ir === dest)?.titulo ?? ''),
    }));
    const abas = abasVisiveis().filter(x => tem(x.nome)).map((x): Cartao => ({ k: 'aba-' + x.id, icon: x.icon, titulo: x.nome, resumo: `${TITULO.abas} › ${x.nome}`, ir: x.id }));
    return [...cards, ...opcoes, ...abas];
  })();

  return (
    // 0.70 (texto 09, E): nas páginas dos Ajustes, puxar da borda esquerda (iPhone) volta uma página, como o "‹".
    // 0.72 (texto 11a, A): na capa dos Ajustes, o gesto vai para o My Planner. CAUSA da tela branca: ativo={!!pagina}
    // desligava a faixa ao voltar para a capa e a tela ficava parada fora (corrigido também no VoltarBorda).
    <VoltarBorda onVoltar={pagina ? voltar : voltarAoMyPlanner}>
    <View style={{ flex: 1, backgroundColor: C.bg }}>
    <ScrollView {...ROLAGEM_TECLADO} ref={scroll} style={{ flex: 1, backgroundColor: C.bg }} keyboardShouldPersistTaps="handled"
      onScroll={e => { desloc.current = e.nativeEvent.contentOffset.y; }} scrollEventThrottle={64}
      contentContainerStyle={{ paddingTop: ins.top + 10, padding: 16, paddingBottom: 140, gap: 10 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        {pagina && <Pressable onPress={voltar} hitSlop={14}><Text style={{ color: C.sub, fontSize: 26 }}>‹</Text></Pressable>}
        <Text style={{ color: C.text, fontSize: 26, fontWeight: '800', flex: 1 }} numberOfLines={2}>{titulo}</Text>{/* 0.72 (texto 10 C6): título longo quebra em 2 linhas, sem cortar */}
      </View>

      {!pagina && (<>
        <AlvoGuia id="ajustes.busca"><Field value={busca} onChangeText={setBusca} placeholder={'🔍 ' + t('Buscar nos ajustes')} autoCorrect={false} semDitado /></AlvoGuia>
        {achados ? (<>
          {achados.map(cartao)}
          {!achados.length && <Text style={{ color: C.sub, textAlign: 'center', marginTop: 12 }}>{t('Nada encontrado nos ajustes.')}</Text>}
        </>) : (<>
          <Card>
            <Text style={{ color: C.text, fontWeight: '700', fontSize: 16 }}>{a.nome || t('Minha conta')}</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              {!!a.cpf && (
                <Pressable onPress={() => setVerCpf(v => !v)} hitSlop={8} accessibilityLabel={verCpf ? t('Esconder o CPF') : t('Ver o CPF inteiro')}
                  style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                  <Text style={{ color: C.sub }}>CPF {verCpf ? mascaraCpf(a.cpf) : cpfParcial(a.cpf)}</Text>
                  <Text style={{ fontSize: 13, opacity: verCpf ? 1 : 0.6 }}>👁️</Text>
                </Pressable>
              )}
              {!!a.cpf && !!a.email && <Text style={{ color: C.sub }}>·</Text>}
              {!!a.email && <Text style={{ color: C.sub, flexShrink: 1 }}>{a.email}</Text>}
            </View>
            <Text style={{ color: sync.status === 'error' || sync.status === 'sessao' ? C.danger : C.sub, fontSize: 12 }}>☁️ {syncTxt}</Text>
            <View style={{ flexDirection: 'row', gap: 8, flexWrap: 'wrap' }}>
              {sync.status === 'sessao'
                ? <Chip cor={C.danger} on small label={t('Entrar de novo')} onPress={() => setReentrar(true)} />
                : <Chip cor={accent} on={false} small label={t('Sincronizar agora')} onPress={() => syncNow()} />}
              <Chip cor={accent} on={false} small label={WEB ? t('Sair deste computador') : t('Sair')} onPress={() => Alert.alert(WEB ? t('Sair deste computador?') : t('Sair da conta?'), t('Seus dados continuam salvos na nuvem.'), [
                { text: t('Cancelar'), style: 'cancel' }, { text: t('Sair'), style: 'destructive', onPress: () => a.signOut() }])} />
            </View>
          </Card>
          {blocos.map(([k, nome, aberto, l]) => l.length > 0 && (
            <Recolhivel key={k} visual="titulo" chave={'ajustes:' + k} inicial={aberto} titulo={nome} gap={10} fixo={k === 'assinatura'}>
              {l.map(cartao)}
            </Recolhivel>
          ))}
        </>)}
        <ReentrarModal visivel={reentrar} onFim={() => setReentrar(false)} />
      </>)}

      {pagina === 'aparencia' && <Aparencia cor={accent} onRodape={setRodape} />}
      {pagina === 'idioma' && <IdiomaMoeda />}
      {pagina === 'avisos' && <Avisos cor={accent} />}
      {pagina === 'calendario' && <Calendario />}
      {pagina === 'feriados' && <Feriados cor={accent} />}
      {pagina === 'seguranca' && <Seguranca cor={accent} onPrivacidade={() => abrir('privacidade')} />}
      {pagina === 'nuvem' && <NuvemCopias cor={accent} />}
      {pagina === 'armazenamento' && <Armazenamento cor={accent} />}
      {pagina === 'meusdados' && <MeusDados cor={accent} onPrivacidade={() => abrir('privacidade')} />}
      {pagina === 'agenda' && <AgendaMapas cor={accent} />}
      {pagina === 'ia' && <IA cor={accent} />}
      {pagina === 'web' && <Card><ConectarNavegador cor={accent} /></Card>}
      {pagina === 'comousar' && <ComoUsar onAbrir={abrir} rolar={rolarGuia} />}
      {pagina?.startsWith('guia:') && <GuiaSubpagina key={pagina} id={pagina.slice(5)} rolar={rolarGuia} />}
      {pagina === 'sobre' && <Sobre cor={accent} />}
      {pagina === 'compras' && <Compras cor={accent} />}
      {pagina === 'privacidade' && <Privacidade cor={accent} />}
      {pagina === 'contato' && <FaleConosco cor={accent} />}
      {pagina === 'indicar' && <Indicar cor={accent} />}
      {pagina === 'paginas' && <PaginasDoApp cor={accent} />}
      {pagina === 'lixeira' && <Lixeira cor={accent} />}
      {pagina === 'abas' && <ListaAbas onAbrir={abrir} onCompras={() => abrir('compras')} />}
      {pagina && ehAba(pagina) && <ConfigAba id={pagina} onCompras={() => abrir('compras')} onAvisos={() => abrir('avisos')} onGuia={() => abrir(('guia:aba:' + pagina) as Pagina)} />}
    </ScrollView>
    {/* texto 07 B1: botões fixos embaixo (fora da rolagem; o espaço de baixo deixa o botão + da barra livre) */}
    {pagina === 'aparencia' && !!rodape && (
      <View style={{ backgroundColor: C.card, borderTopWidth: 1, borderTopColor: C.line, paddingHorizontal: 16, paddingTop: 10, paddingBottom: 36 }}>{rodape}</View>
    )}
    </View>
    </VoltarBorda>
  );
}
